import Button from "@components/atoms/button";
import { ButtonHTMLAttributes } from "react";
import { translate } from "@locales";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "default" | "small";
  isFollow?: boolean;
}

export default function FollowButton(props: Props) {
  const { isFollow, size, ...rest } = props;

  return isFollow ? (
    <Button.Pill variant="secondary" size={size} {...rest}>
      {translate("base.following")}
    </Button.Pill>
  ) : (
    <Button.Pill size={size} {...rest}>
      {translate("base.follow")}
    </Button.Pill>
  );
}
